// --------------------- Import Globais ---------------------
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
// --------------------- Import Antd-Design ---------------------
import { Modal, Form, Input } from "antd";

// --------------------- Import Styles ---------------------
import { formStyle, layout, Title } from "../styles";

// --------------------- Import Hooks ---------------------

// --------------------- Import Uteis ---------------------
import { useError } from "../../../uteis/mensagens/useError";
import { useSuccess } from "../../../uteis/mensagens/useSuccess";

// --------------------- Import dayJS --------------------
import { useAtualizarPostagem } from "../hooks/useAtualizarPostagem";

export default function ModalNotas({
  isModalOpen,
  handleFechar,
  postagemId,
  observacao,
}: any) {
  const [formPostagem] = Form.useForm();

  // Chamada da função de atualização
  const {
    atualizar,
    isLoading: isLoadingAtualizar,
    error,
    success,
  } = useAtualizarPostagem();

  const errorRef = useRef<boolean | null>(false);

  // Atualiza o valor de errorRef e warningRef toda vez que o error e warning mudar
  useEffect(() => {
    if (error) {
      errorRef.current = error;
    }
  }, [error]);

  // Estado inicial de dos dados Postagem que serão atualizados
  const [postagemData, setPostagemData] = useState<any>({});

  // Função que armazena os dados alterados de Apartamento
  const postagemChange = (changedValues: Partial<any>, allValues: any) => {
    setPostagemData(allValues);
  };

  // Exibe a Mensagem de  Erro
  const { showError, contextHolder: errorContextHolder } = useError();

  // Exibe a Mensagem de  Sucesso
  const { showSuccess, contextHolder: successContextHolder } = useSuccess();

  // Estados para controlar as exibições
  const [errorDisplayed, setErrorDisplayed] = useState(false);
  const [successDisplayed, setSuccessDisplayed] = useState(false);

  // Hook de navegação do React Router
  const navigate = useNavigate();

  const hoje = new Date();

  useEffect(() => {
    if (isModalOpen) {
      // Exibe a mensagem de sucesso
      if (success && !successDisplayed) {
        const msgSuccess = "Observação atualizada com sucesso!";
        showSuccess(msgSuccess);
        setSuccessDisplayed(true);

        // Limpa estado de sucesso após 3 segundos e recarrega a página
        setTimeout(() => {
          setSuccessDisplayed(false);
          navigate(0);
        }, 3000);
      }

      // Exibe a mensagem de erro
      if (errorRef.current && !errorDisplayed) {
        const msgError =
          "Não foi possível atualizar a observação! Tente Novamente!";
        showError(msgError);
        setErrorDisplayed(true);

        // Limpa estado de error após 3 segundos
        setTimeout(() => {
          setErrorDisplayed(false);
          errorRef.current = null;
        }, 3000);
      }
    } else {
      // Reseta os estados ao fechar o modal
      setSuccessDisplayed(false);
      setErrorDisplayed(false);
    }
  }, [
    isModalOpen,
    success,
    showSuccess,
    showError,
    errorDisplayed,
    successDisplayed,
    navigate,
  ]);

  /* eslint-disable no-template-curly-in-string */ // Constante que válida os campos de todos os  formulário
  const validarFormulario = {
    required: "${label} é necessário!",
  };
  /* eslint-enable no-template-curly-in-string */

  useEffect(() => {
    if (!formPostagem) {
      return;
    }
    
    formPostagem.setFieldsValue({
      observacoes: observacao
    });
  }, [formPostagem, observacao]);

  return (
    <>
      <Modal
        open={isModalOpen}
        onCancel={handleFechar}
        cancelText="Cancelar"
        okText="Atualizar"
        onOk={() => atualizar(postagemId, postagemData)}
        confirmLoading={isLoadingAtualizar}
        okButtonProps={{
          style: {
            backgroundColor: "#003644",
            borderColor: "#003644",
            color: "white",
          }, // Botão "Ativar" com fundo verde
        }}
        cancelButtonProps={{
          style: {
            backgroundColor: "#f44336",
            borderColor: "#f44336",
            color: "white",
          }, // Botão "Cancelar" com fundo vermelho
        }}
      >
        {
          <>
            <>{errorContextHolder}</>
            <>{successContextHolder}</>

            <Form
              {...layout}
              form={formPostagem}
              onValuesChange={(changedValues, allValues) =>
                postagemChange(changedValues, allValues)
              }
              name="postagem"
              style={formStyle}
              validateMessages={validarFormulario}
            >
              <Title>Observações</Title>

              <Form.Item
                name={["observacoes"]}
                label=""
                className="formItems"
              >
                <Input.TextArea rows={10}  />
              </Form.Item>
            </Form>
          </>
        }
      </Modal>
    </>
  );
}
